import { FlagIcon } from "lucide-react";

import { Group, Heading, Link, Text } from "@chakra-ui/react";

import { Button } from "@components/ui/button";

import { openPlanSelection } from "@utils/monday-plans";

const NO_SUBSCRIPTION_SCREEN = ({ email }: { email: string }) => {
  const mailToLink = `mailto:${email}`;

  return (
    <Group flexDirection="column">
      <FlagIcon
        size={48}
        className="text-red-500"
      />

      <Heading size="xl"> Choose a plan to continue using Xero for monday.com</Heading>
      <Text
        mt={2}
        fontSize="md"
        color="gray.600"
        textAlign="center"
        maxW="600px"
      >
        Your access to <strong>Xero for monday.com</strong> is currently paused. It looks like your trial has
        ended or there’s no active subscription on your account. To keep syncing your Xero invoices, contacts,
        and more directly within monday.com, just upgrade your plan.
      </Text>

      <Button
        mt={6}
        size="md"
        w="full"
        colorPalette="blue"
        onClick={openPlanSelection}
      >
        Choose a plan
      </Button>

      <Text
        mt={4}
        fontSize="sm"
        color="gray.500"
      >
        Need help? Contact{" "}
        <Link
          href={mailToLink}
          color="blue.500"
        >
          {email}
        </Link>
      </Text>
    </Group>
  );
};

export default NO_SUBSCRIPTION_SCREEN;
